/** Textos de pantalla de Base + velocidad (Actualizaciones v2). Aparte de strings.ts para no chocar con los otros cambios. */
const T = {
	retry: "Reintentar",
	estadoCuenta: "Estado de Cuenta",
	abrirEstadoCuenta: "Abrir Completo",
	pendiente: "Pendiente",
	vencido: "Vencido",
	pagado: "Pagado",
	pagadoHasta: "Pagado Hasta",
	alCorriente: "Al Corriente",
	nada: "—",
	saldo: "Saldo",
	cargarMas: "Cargar Más",
	deTotal: (n: number, total: number) => `${n} de ${total}`,
	sinPermisoDinero: "Sin permiso para ver el Estado de Cuenta en este plantel.",
	sinMovimientos: "Sin cobros en este plantel.",
	cerrar: "Cerrar",
	horarioAnterior: "Horario anterior",
	col: { concepto: "Concepto", vence: "Vence", estado: "Estado", total: "Total", pagado: "Pagado", pendiente: "Pendiente", factura: "Factura", fecha: "Fecha" },
	articulos: "Kits y Productos",
	totalPendiente: "Total Pendiente"
};

export default T;
